import { appInsights } from "./AppInsights";

export const freeTrailClickFunction = () => {
  appInsights.trackEvent({ name: "7 Days Free Trial Clicked" });
};
